<script setup lang="ts">
import type { PageItem } from '@/types/model'
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import type { ColorKey } from '@/types/tailwind'
import DropdownItem from '@/components/dropdown/DropdownItem.vue'

// props & emit
const props = withDefaults(
  defineProps<{
    data: PageItem
    path?: string | undefined
  }>(),
  {
    path: '',
  },
)

// router & route
const router = useRouter()
const route = useRoute()

// computed
const page = computed(() => props.data as PageItem)
const icon = computed(() => page.value?.icon || 'list')
const color = computed(() => page.value?.color || ('blue' as ColorKey))

// method
const clickItemMenu = async () => {
  await router.push({
    name: page.value.url,
  })
}

const isActive = (): boolean => page.value.url === route.name
</script>

<template>
  <dropdown-item
    @click="clickItemMenu"
    :color="color"
    :icon="icon"
    :text="page.name"
    :desc="page.desc"
    :active="isActive()"
  ></dropdown-item>
</template>

<style scoped></style>
